<template>
  <div class="_modals">
    <b-modal ref="modalPaymentRejected"
            centered
            hide-footer
            title="">
      <div>
        <div class="text-center mb-3">
            <img src="@/assets/image/icon/Group 3716.svg" style="width: 70px;" alt="">
        </div>
        <p class="text-center">
            {{errorMessage}}
        </p>
      </div>
    </b-modal>

    <b-modal id="modalPaymentPartialHistory"
             ref="modalPaymentPartialHistory"
             centered
             hide-footer
             title="Payment History">
      <div class="row m-0 mb-2 historytitle">
        <div class="col-md p-0">Date</div>
        <div class="col-md p-0">Payment Amount</div>
        <div class="col-md p-0"></div>
      </div>
      <div v-if="!getPaymentHistory || getPaymentHistory.length < 1">
        -
      </div>
      <div v-else>
        <div class="row mx-0 historytable" v-for="item in history.list" :key="item.id">
          <div class="col-md historytable__light">{{ item.date }}</div>
          <div class="col-md historytable__blue">
            {{ item.amount | currency('IDR', 0, { spaceBetweenAmountAndSymbol: true }) }}
          </div>
          <div class="col-md historytable__light">
            <div class="row m-0 historytable__light--download">
              <img src="@/assets/image/icon/download-down-blue.svg" alt="">
              <a @click="downloadProof(item)" class="ml-2">Proof of Payment</a>
            </div>
          </div>
        </div>
      </div>

      <div class="text-center mt-4 mb-3">
        <button type="submit"
                @click="closeModal"
                class="button__bluesmall py-2 px-5">OK</button>
      </div>
    </b-modal>

    <b-modal id="modalPaymentUploadProof"
             ref="modalPaymentUploadProof"
             centered
             hide-footer
             no-close-on-backdrop
             @hidden="resetModalProof()"
             title="Pay Partialy">
      <div class="uploadcontent" style="padding: 8px 0">
        <h6>Bank Account</h6>
        <div class="row uploadcontent__copied">
          <img src="@/assets/image/icon/BCA_logo.png" alt="">
          <span class="mx-2 px-4 py-2">2913188098</span>
          <h6 class="mt-3">Acc Name: PT. Eximku Teknologi Indonesia</h6>
        </div>
        <hr>
        <div v-if="isLoadingPaymentDetail"
             class="spinner__small--blue d-flex justify-content-center">
          <b-spinner label="Loading..."></b-spinner>
        </div>
        <div v-else-if="getPaymentDetail" class="uploadcontent__payment">
          <h6>Payment Meter</h6>
          <div class="uploadcontent__payment--meter mt-3">
            <p class="mb-1">Last Payment:
              <span v-if="getPaymentDetail.lastPayment">
                {{getDateFormat2(getPaymentDetail.lastPayment)}}
              </span>
              <span v-else>-</span>
            </p>
            <div class="meterbar" :class="paidPercent">
              <div class="meterbar__progress" :style="payablePercent"></div>
              <p>
                {{ getPaymentDetail.paid | currency('IDR', 0, { spaceBetweenAmountAndSymbol: true }) }} paid
                from total {{ getPaymentDetail.total | currency('IDR', 0, { spaceBetweenAmountAndSymbol: true }) }}
               </p>
            </div>
            <p class="mt-2">Remaining Payable Amount: {{ getPaymentDetail.payable | currency('IDR', 0, { spaceBetweenAmountAndSymbol: true }) }}</p>
          </div>
        </div>
        <hr>
        <div class="uploadcontent__payment">
          <h6>Partial Payment</h6>
          <form @submit.prevent="uploadProofPayment()">
            <div class="row mx-0 mt-3 input__defaultgroupform">
              <p class="mb-1">Enter Recent Payment Amount</p>
              <b-input-group required class="input__defaultgroupform--money" prepend="IDR">
                <money v-model="form.totalpayment" ></money>
              </b-input-group>
            </div>
            <div class="row mx-0 mt-3 input__attach">
              <p class="mb-1">Upload Proof of Payment</p>
              <b-form-file
                  v-model="form.file"
                  required
                  name="fileDocumentShipment"
                  accept=".pdf, .xls, .doc, .docx, .xlsx, .png, .jpeg">
              </b-form-file>
            </div>
            <div class="text-center m-4">
              <button type="submit"
                      :disabled="form.totalpayment < 10"
                      class="button__bluesmall py-2 px-5 mb-3">
                    <span v-if="isLoadingPartialProof"
                          class="spinner__small--white">
                        <b-spinner label="Loading..."></b-spinner>
                    </span>
                    <span v-else>Upload</span>
              </button>
              <p v-if="errorPartialProof" class="fontstyle__errormsg mt-2">
                {{errorPartialProof.message}}
              </p>
            </div>
          </form>
        </div>
      </div>
    </b-modal>

    <b-modal id="modalSelectPaymentType"
             ref="modalSelectPaymentType"
             @hidden="resetModalPaymentType"
             centered
             hide-footer
             hide-header>
      <div class="">
        <p class="text-left pt-3 pb-3">
          Which One of These Type of Payment You Prefer the Most ?
        </p>
          <div class="selecttype">
            <b-form-group>
              <b-form-radio-group
                id="radio-group-type"
                v-model="selectedPaymentType"
                :options="optionsPaymentType"
                name="radio-options"
              ></b-form-radio-group>
            </b-form-group>
          </div>
          <div class="row mx-0 my-4 justify-content-center">
            <button type="button" @click="closeModal"
                    class="button__redsmall py-2 mr-3">Cancel</button>
            <button type="button" @click="processpayment(selectedPaymentType)"
                    class="button__bluesmall py-2">
                    <span class="spinner__small--white" v-if="isLoadingCreatePayment">
                      <b-spinner label="Loading..."></b-spinner>
                    </span>
                    <span v-else>Process</span>
              </button>
          </div>
          <div v-if="errorCreatePayment" class="fontstyle__errormsg text-center">
            {{ errorCreatePayment.message}}
          </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import mixinDateTime from '@/mixin/getters/date-time'

export default {
  mixins: [mixinDateTime],
  data: () => ({
    errorMessage: '',
    form: {
      totalpayment: null,
      id: null,
      file: null
    },
    selectedPaymentList: [],
    selectedInvoice: {
      id: [],
      number: [],
      total: []
    },
    history: {
      id: 0,
      list: [{
        id: null,
        date: null,
        amount: null,
        action: ''
      }]
    },
    payablePercent: '',
    paidPercent: '',
    selectedPaymentType: 'FULL',
    optionsPaymentType: [
      { text: 'Full Payment at Once', value: 'FULL' },
      { text: 'Partial Payment', value: 'PARTIAL' }
    ],
    paymentMethod: '',
    paymentBank: 'BCA'
  }),
  computed: {
    ...mapGetters({
      createPayment: 'payment/createPayment',
      errorCreatePayment: 'payment/errorCreatePayment',
      isLoadingCreatePayment: 'payment/isLoadingCreatePayment',

      getPaymentHistory: 'payment/getPaymentHistory',
      errorPaymentHistory: 'payment/errorPaymentHistory',
      isLoadingPaymentHistory: 'payment/isLoadingPaymentHistory',

      getPaymentDetail: 'payment/getPaymentDetail',
      errorPaymentDetail: 'payment/errorPaymentDetail',
      isLoadingPaymentDetail: 'payment/isLoadingPaymentDetail',

      putPartialProof: 'payment/putPartialProof',
      errorPartialProof: 'payment/errorPartialProof',
      isLoadingPartialProof: 'payment/isLoadingPartialProof',

      isDownloading: 'payment/isDownloading',
      errorDownloading: 'payment/errorDownloading'
    })
  },
  created () {
    this.$eventHub.$on('dialog-payment-rejected', this.paymentRejectedInfo)
    this.$eventHub.$on('dialog-payment-partial-history', this.dialogPartialHistory)
    this.$eventHub.$on('dialog-payment-partial-proof', this.dialogPartialProof)
    this.$eventHub.$on('dialog-payment-select-type', this.dialogPaymentType)
  },
  beforeDestroy () {
    this.$eventHub.$off('dialog-payment-rejected')
    this.$eventHub.$off('dialog-payment-partial-history')
    this.$eventHub.$off('dialog-payment-partial-proof')
    this.$eventHub.$off('dialog-payment-select-type')
  },
  methods: {
    closeModal () {
      this.$refs.modalPaymentPartialHistory.hide()
      this.$refs.modalSelectPaymentType.hide()
    },

    paymentRejectedInfo (errorMessage) {
      this.errorMessage = errorMessage
      this.$refs.modalPaymentRejected.show()
    },

    async dialogPartialHistory (id) {
      this.history.id = id
      await this.$store.dispatch('payment/FETCH_PAYMENT_HISTORY', id)
      await this.$store.dispatch('payment/FETCH_PAYMENT_DETAIL', id)
      this.$refs.modalPaymentPartialHistory.show()
      this.modifyList()
    },

    async dialogPartialProof (id) {
      this.form.id = id
      await this.$store.dispatch('payment/FETCH_PAYMENT_DETAIL', id)
      this.$refs.modalPaymentUploadProof.show()
      return new Promise((resolve) => {
        if (this.getPaymentDetail) {
          const payment = this.getPaymentDetail
          const percent = this.getPersentase(payment.paid, payment.total)
          this.payablePercent = `width: ${percent}%`
          if (percent < 31 && percent > 0) { // set bg if payment < 31%
            this.payablePercent = `width: ${percent}%; background-color: #f07b87`
            this.paidPercent = 'meterbar__red'
          }
        }
        return resolve()
      })
    },

    getPersentase (paid, total) {
      let persentase = ((paid / total) * 100).toFixed(2)
      return persentase
    },

    dialogPaymentType (listpayment) {
      this.selectedPaymentList = listpayment
      this.$refs.modalSelectPaymentType.show()
    },

    resetModalPaymentType () {
      this.selectedPaymentList = []
      this.selectedPaymentType = 'FULL'
    },

    modifyList () {
      const localItems = []
      this.history.list = []
      return new Promise((resolve) => {
        if (this.getPaymentHistory) {
          this.getPaymentHistory.forEach(el => {
            const newItem = {
              id: el.id,
              date: this.getDateFormat2(el.created_at),
              amount: el.amount,
              fileName: `Proof_${el.payment_number}${el.file_ext}`
            }
            localItems.push(newItem)
          })
          this.history.list = localItems
        }
        return resolve()
      })
    },

    async processpayment (type) {
      this.selectedPaymentList.forEach((item) => {
        this.selectedInvoice.id.push(item.id)
        this.selectedInvoice.number.push(item.invoice_number)
        this.selectedInvoice.total.push(item.total_grand)
      })
      const totalInvoice = this.selectedInvoice.total.join()
      if (type === 'FULL') {
        this.$store.dispatch('payment/PAYMENT_PROCESS_TEMP', {
          idInvoice: this.selectedInvoice.id,
          invoiceList: this.selectedInvoice.number,
          total: totalInvoice
        })
        this.$router.push({ name: 'PaymentNow' })
        this.$refs.modalSelectPaymentType.hide()
      } else if (type === 'PARTIAL') {
        const payload = {
          id_invoice: this.selectedInvoice.id,
          bank: 'BCA',
          method: 'transfer',
          typeOfPayment: 'PARTIAL'
        }
        await this.$store.dispatch('payment/CREATE_PAYMENT', payload)
        this.getStatusCratePayment()
      }
    },

    getStatusCratePayment () {
      return new Promise((resolve) => {
        if (this.createPayment) {
          this.$router.push({
            name: 'Payment',
            params: { type: 'partial-payment' }
          })
          this.$refs.modalSelectPaymentType.hide()
        }
        return resolve()
      })
    },

    async uploadProofPayment () {
      const form = new FormData()
      form.append('paymentTotal', this.form.totalpayment)
      form.append('paymentId', this.form.id)
      form.append('fileDocument', this.form.file)
      if (this.form.id) {
        await this.$store.dispatch('payment/PUT_PAYMENT_PARTIAL_PROOF', form)
      } else {
        console.log('Undefined ID', this.form.id)
      }
    },

    async downloadProof (item) {
      const payload = {
        id: item.id,
        fileName: item.fileName
      }
      await this.$store.dispatch('payment/DOWNLOAD_PROOF', payload)
    },

    resetModalProof () {
      this.form = {
        totalpayment: 0,
        id: null,
        file: null
      }
    }
  },
  watch: {
    putPartialProof (data) {
      if (data) {
        this.$refs.modalPaymentUploadProof.hide()
      }
    },
    errorCreatePayment (data) {
      if (data) {
        this.selectedInvoice = {
          id: [],
          number: [],
          total: []
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/global/modals/Payment.vue